import { makeStyles } from '@fluentui/react-components';
import React from 'react';
import { Outlet } from 'react-router-dom';
import { SiteHeader } from './SiteHeader';
import { withStyles } from "./withStyles";
import { VentLog } from "../model/VentLog";
import { RexDateTime } from '../Dates/RexDateTime';

export interface VentLogItemProps
{
    styles: Record<string, string>;
    ventLog: VentLog;
    firstReading: Date;
}

export interface VentLogItemState
{
}

const useStyles = makeStyles(
    {
    });

export class VentLogItemWithoutStyles extends React.Component<VentLogItemProps, VentLogItemState>
{
    render()
    {
        const ventLog = this.props.ventLog;
        const date = (ventLog.Timestamp as RexDateTime).toLocalTimeString();

        return (
            <tr>
                <td>
                    {date}
                </td>
                <td>
                    {ventLog.Vent1}
                </td>
                <td>
                    {ventLog.Vent2}
                </td>
                <td>
                    {ventLog.Vent3}
                </td>
                <td>
                    {ventLog.Comment}
                </td>
            </tr>
        );
    }
}

export const VentLogItem = withStyles(useStyles, VentLogItemWithoutStyles);